const images = {
  logo: require("./logo.png"),
  logoFooter: require("./logo-footer.png"),
  noImage: require("./no-image.jpg"),
  hekateLogo: require("./hekate.png"),
  ATLogo: require("./AT.png"),
  fundepsLogo: require("./fundeps.png"),
  sanarLogo: require("./Sanar.png"),
  resourceCenter: require("./resource-center.png"),
  bgAuth: require("./bg-auth.png"),
  headerBtn: require("./header-btn.jpg"),
  unicefLogo: require("./unicef.png"),
  aboutUs: require("./about-us.png"),
  aboutUs1: require("./about-us-1.png"),
  bannerIcon: require("./banner-icon.png"),
  bannerIcon1: require("./banner-icon-1.png"),
  bannerIcon2: require("./banner-icon-2.png"),
  popup: require("./popup.png"),
  popup1: require("./popup1.png"),
  popup2: require("./popup2.png"),
  popup3: require("./popup3.png"),
  popupIcon: require("./popup-icon.png"),
  sosIcon: require("./sos.png"),
  card: require("./card.png"),
  card1: require("./card-1.png"),
  card2: require("./card-2.png"),
  cardIcon: require("./card-icon.png"),
  map: require("./map.png"),
  mapIcon: require("./map-icon.png"),
  detection: require("./detection.png"),
  legal: require("./legal.png"),
  legalIcon: require("./legal-icon.png"),
  legalNation: require("./legal-nation.png"),
  legalInternational: require("./legal-international.png"),
  legalIconFooter: require("./legal-icon-footer.png"),
  legalIconFooter1: require("./legal-icon-footer-1.png"),
  searchIcon: require("./search-icon.png"),
  userManualIcon: require("./user-manual-icon.png"),
  infraccionesGuide1: require("./infracciones-guide/image1.jpeg"),
  infraccionesGuide2: require("./infracciones-guide/image2.jpeg"),
  infraccionesGuide3: require("./infracciones-guide/image3.jpeg"),
  infraccionesGuide4: require("./infracciones-guide/image4.png"),
  infraccionesGuide5: require("./infracciones-guide/image5.jpeg"),
  infraccionesGuide6: require("./infracciones-guide/image6.jpeg"),
  infraccionesGuide7: require("./infracciones-guide/image7.png"),
  videoTemp: require("./video-temp.png"),
  slider: require("./slider.png"),
  slider1: require("./slider1.png"),
  slider2: require("./slider2.png"),
  slider3: require("./slider3.png"),
  slider4: require("./slider4.png"),
  jotForm: require("./jot-form.png"),
  jotForm1: require("./jot-form-1.png"),
  sliderAboutUs1: require("./slide-about-us-1.png"),
  sliderAboutUs2: require("./slide-about-us-2.png"),
  sliderAboutUs3: require("./slide-about-us-3.png"),
  sliderAboutUs4: require("./slide-about-us-4.png"),
  sliderAboutUs5: require("./slide-about-us-5.png"),
  sliderAboutUs6: require("./slide-about-us-6.png"),
  sliderAboutUs7: require("./slide-about-us-7.png"),
  sliderAboutUs8: require("./slide-about-us-8.png"),
  sliderAboutUs9: require("./slide-about-us-9.png"),
  logoFooter1: require("./logo-footer-1.png"),
  logoFooter2: require("./logo-footer-2.png"),
  logoFooter3: require("./logo-footer-3.png"),
  logoFooter4: require("./logo-footer-4.png"),
  logoFooter5: require("./logo-footer-5.png"),
  logoFooter6: require("./logo-footer-6.png"),
  logoFooter7: require("./logo-footer-7.png"),
  logoFooter8: require("./logo-footer-8.png"),
  logoFooter9: require("./logo-footer-9.png"),
  logoFooterAlsanna: require("./logo-footer-ALSANNA.png"),
  logoFooterCensia: require("./logo-footer-CENSIA.png"),
  logoFooterConsejoNuevoLeon: require("./logo-footer-CONSEJO-NUEVO-LEON.png"),
  logoFooterEPC: require("./logo-footer-EPC.png"),
  logoFooterIbfan: require("./logo-footer-IBFAN.png"),
  logoFooterSalud: require("./logo-footer-SALUD.png"),
  logoFooterUAM: require("./logo-footer-UAM.png"),
  logoFooterReyhan: require("./logo-footer-REYHAN.png"),
  jotFormBtn: require("./jotform-submit-btn.png"),
};

export default images;
